module.exports = __webpack_public_path__ + "static/media/Invite.c4a32984.svg";